<template>
  <div class="price-con">
    <div class="normal-price" v-if="isPrice">
      <em>￥</em>
      <span>{{normalPrice | priceFormat}}</span>
    </div>
    <div class="group-price" v-if="isGroupPrice && groupPrice">
      <img class="icon-group" src="../../assets/images/v5.8/group.png">
      <div class="group-con-r">
        <em>￥</em>
        <span>{{groupPrice | priceFormat}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    normalPrice: {
      default: 0,
      type: Number
    },
    groupPrice: {
      default: 0,
      type: Number
    },
    isPrice: {
      default: true,
      type: Boolean
    },
    isGroupPrice: {
      default: 1,
      type: Number
    }
  },
  data () {
    return {

    }
  },
  computed: {},
  filter: {},
  mounted () { },
  update () { },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.price-con{
  display: flex;
}
.normal-price {
  color: #FF4B4B;
  font-weight: bold;
  display: flex;
  align-items: flex-end;
  margin-right: 8px;
  line-height: 1;
  em {
    display: inline-block;
    font-style: inherit;
    font-size: 12px;
    transform: translateY(-1px);
  }
  span {
    font-size: 18px;
    height: 18px;
    line-height: 18px;
    display: inline-block;
  }
}
.group-price {
  display: flex;
  align-items: center;
  .icon-group {
    height: 14px;
    width: 14px;
    transform: translateY(-0.5px);
  }
  .group-con-r {
    color: #ff2f47;
    display: flex;
    line-height: 1;
    em {
      font-weight: bold;
      font-style: inherit;
      font-size: 12px;
      display: flex;
      align-items: flex-end;
      transform: translateY(-1px);
    }
    span {
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
    }
  }
}
</style>
